import { useMemo } from 'react';

import { ServiceLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { Bean, ValidationRules } from '@dreryk/react-common';
import { FormController, TextView } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../../translations';
import { ServiceLocationText } from '../../../../../../shared/components/ServiceLocationText';
import { ReceptionServiceFormController } from '../../../ReceptionServiceForm';

const t = receptionServiceTranslationKeys.shared.form.components.serviceLocationTextView;

type ServiceLocationsTextViewProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly defaultValue: ServiceLocation;
};

export const ServiceLocationsTextView = (props: ServiceLocationsTextViewProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: true,
      };
   }, []);

   return (
      <FormController<ServiceLocation>
         controller={props.register('serviceLocation', validationRules)}
         defaultValue={props.defaultValue}
      >
         {({ value }) => (
            <TextView testId={'serviceLocation'} label={t.label}>
               <ServiceLocationText serviceLocation={value} />
            </TextView>
         )}
      </FormController>
   );
};
